export const MandatorySignal = (): string => {
  return '*';
};
